/* Cart upsell ("Pairs Well With") - delegated handlers, survive drawer re-renders. */
(function () {
  // Bind once on document so handlers survive the cart drawer being
  // re-rendered/morphed after add-to-cart (injected inline scripts never re-run).
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;
  function getSection() { return document.getElementById('cart-upsell-section'); }
  var section = {
    querySelector: function (q) { var s = getSection(); return s ? s.querySelector(q) : null; },
    querySelectorAll: function (q) { var s = getSection(); return s ? s.querySelectorAll(q) : []; }
  };

  // Helper: get variants data for a product
  function getVariants(productId) {
    var el = document.getElementById('upsell-variants-' + productId);
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch(e) { return []; }
  }

  // Helper: get all selected options for a product
  function getSelectedOptions(productId) {
    var selected = {};
    // swatches
    var selectedSwatch = section.querySelector('.cart-upsell__swatch-btn.is-selected[data-product-id="' + productId + '"]');
    if (selectedSwatch) {
      selected['swatch'] = selectedSwatch.dataset.value;
    }
    // pills
    var selectedPills = section.querySelectorAll('.cart-upsell__pill-btn.is-selected[data-product-id="' + productId + '"]');
    selectedPills.forEach(function(p) {
      selected['pill_' + p.dataset.optionPosition] = p.dataset.value;
    });
    return selected;
  }

  // Helper: find matching variant from selected values
  function findVariant(productId) {
    var variants = getVariants(productId);
    var selectedSwatch = section.querySelector('.cart-upsell__swatch-btn.is-selected[data-product-id="' + productId + '"]');
    var selectedPills = section.querySelectorAll('.cart-upsell__pill-btn.is-selected[data-product-id="' + productId + '"]');

    var selectedValues = [];
    if (selectedSwatch) selectedValues.push(selectedSwatch.dataset.value);
    selectedPills.forEach(function(p) { selectedValues.push(p.dataset.value); });

    return variants.find(function(v) {
      return selectedValues.every(function(val) {
        return v.options.indexOf(val) !== -1;
      });
    });
  }

  // Helper: update add button state
  function updateAddBtn(productId) {
    var addBtn = section.querySelector('.cart-upsell__add-btn--multi[data-product-id="' + productId + '"]');
    if (!addBtn) return;

    var variant = findVariant(productId);
    if (variant) {
      addBtn.dataset.variantId = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.querySelector('.cart-upsell__btn-text').textContent = variant.available ? 'ADD' : 'SOLD OUT';

      // Update product image if variant has one
      if (variant.image) {
        var img = document.getElementById('upsell-img-' + productId);
        if (img && variant.image !== 'null') {
          img.style.opacity = '0.6';
          img.src = variant.image;
          img.onload = function() { img.style.opacity = '1'; };
        }
      }
    } else {
      addBtn.disabled = true;
    }
  }

  // SELECT toggle
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element) || !e.target.closest('#cart-upsell-section')) return;
    var toggle = e.target.closest('.cart-upsell__select-toggle');
    if (!toggle) return;

    var productId = toggle.dataset.productId;
    var defaultState = document.getElementById('upsell-default-' + productId);
    var pickerState = document.getElementById('upsell-picker-' + productId);
    var addBtn = section.querySelector('.cart-upsell__add-btn--multi[data-product-id="' + productId + '"]');

    var isOpen = pickerState && pickerState.style.display !== 'none';

    if (isOpen) {
      // Close
      if (defaultState) defaultState.style.display = '';
      if (pickerState) pickerState.style.display = 'none';
      if (addBtn) addBtn.style.display = 'none';
      toggle.style.display = '';
      toggle.textContent = 'SELECT';
    } else {
      // Open
      if (defaultState) defaultState.style.display = 'none';
      if (pickerState) pickerState.style.display = 'flex';
      if (addBtn) addBtn.style.display = 'inline-flex';
      toggle.style.display = 'none';
    }
  });

  // Swatch click
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element) || !e.target.closest('#cart-upsell-section')) return;
    var btn = e.target.closest('.cart-upsell__swatch-btn');
    if (!btn || btn.classList.contains('cart-upsell__swatch-btn--unavailable')) return;

    var productId = btn.dataset.productId;
    // Deselect siblings
    section.querySelectorAll('.cart-upsell__swatch-btn[data-product-id="' + productId + '"]').forEach(function(s) {
      s.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    updateAddBtn(productId);
  });

  // Pill click
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element) || !e.target.closest('#cart-upsell-section')) return;
    var btn = e.target.closest('.cart-upsell__pill-btn');
    if (!btn) return;

    var productId = btn.dataset.productId;
    var optionPosition = btn.dataset.optionPosition;
    // Deselect siblings in same option
    section.querySelectorAll('.cart-upsell__pill-btn[data-product-id="' + productId + '"][data-option-position="' + optionPosition + '"]').forEach(function(s) {
      s.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    updateAddBtn(productId);
  });

  // Add to cart
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element) || !e.target.closest('#cart-upsell-section')) return;
    var btn = e.target.closest('.cart-upsell__add-btn');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        btn.classList.remove('is-loading');
        console.error('Cart add error:', data.description);
        return;
      }

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.querySelector('.cart-upsell__btn-text').textContent = '✓';

      var item = btn.closest('.cart-upsell__item');
      setTimeout(function() {
        item.classList.add('is-removing');
        item.addEventListener('animationend', function() {
          item.remove();
          var sec = getSection(); if (sec && !sec.querySelector('.cart-upsell__item')) sec.remove();
        }, { once: true });
      }, 600);

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
          var cartComponent = document.querySelector('cart-items-component[data-drawer]');
          if (cartComponent) {
            var sectionId = cartComponent.dataset.sectionId;
            if (sectionId) {
              fetch('/?sections=' + sectionId)
                .then(function(r) { return r.json(); })
                .then(function(sections) {
                  if (sections[sectionId]) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(sections[sectionId], 'text/html');
                    var newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
                    var currentInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
                    if (newInner && currentInner) {
                      currentInner.innerHTML = newInner.innerHTML;
                    }
                  }
                });
            }
          }
        });
    })
    .catch(function(err) {
      btn.classList.remove('is-loading');
      console.error('Cart error:', err);
    });
  });
})();
